import { useEffect } from "react";

import type { SectionNameType } from "@features/article-content/model";
import { useArticleContext } from "@features/article-content/ui/article-context";

import { useIntersectionObserver } from "@shared/hooks/use-intersection-observer";
import { processText } from "@shared/utils/string";

export const SectionName = (props: SectionNameType) => {
  const { name } = props;

  const { setSection } = useArticleContext();

  const [ref, inView] = useIntersectionObserver<HTMLDivElement>({
    triggerOnce: false,
    threshold: 1,
    rootMargin: "0% 0% -20% 0%",
  });

  useEffect(() => {
    if (inView) {
      setSection(`section-${processText(name)}`);
    }
  }, [setSection, name, inView]);

  return <div ref={ref} id={`section-${processText(name)}`} />;
};

SectionName.displayName = "SectionName";
